/**
 * Stores List - Filter functionality
 */

class StoresFilter {
  constructor() {
    this.filterSelect = document.getElementById('city-filter');
    this.storeCards = document.querySelectorAll('.store-card');
    this.noResultsMessage = document.querySelector('.stores-no-results');
    
    if (this.filterSelect && this.storeCards.length > 0) {
      this.init();
    }
  }
  
  init() {
    // Add change event listener
    this.filterSelect.addEventListener('change', (e) => {
      this.filterStores(e.target.value);
    });
    
    // Smooth scroll after filter if needed
    this.filterSelect.addEventListener('change', () => {
      setTimeout(() => {
        const grid = document.querySelector('.stores-grid');
        if (grid) {
          const rect = grid.getBoundingClientRect();
          if (rect.top < 0) {
            grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      }, 100);
    });
  }
  
  filterStores(selectedCity) {
    let visibleCount = 0;
    
    this.storeCards.forEach((card) => {
      const cardCity = card.getAttribute('data-city');
      
      if (selectedCity === 'all' || cardCity === selectedCity) {
        card.classList.remove('hidden');
        card.style.display = '';
        visibleCount++;
        
        // Trigger animation
        card.style.animation = 'none';
        setTimeout(() => {
          card.style.animation = '';
        }, 10);
      } else {
        card.classList.add('hidden');
        card.style.display = 'none';
      }
    });
    
    // Show/hide no results message
    if (this.noResultsMessage) {
      if (visibleCount === 0) {
        this.noResultsMessage.style.display = 'block';
      } else {
        this.noResultsMessage.style.display = 'none';
      }
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new StoresFilter();
  });
} else {
  new StoresFilter();
}

